import script from "./OrganismsNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsNavigation.vue?vue&type=style&index=0&id=8b28d0fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b28d0fa"]])

export default __exports__